<template>
  <v-dialog v-model="open" persistent fullscreen eager :transition="false">
    <v-card>
      <v-card-text class="pa-0 pad-container" :style="{ height: padH }">
        <VueSignaturePad ref="signaturePad" width="100%" :height="padH" :options="options" />
      </v-card-text>
      <v-card-actions class="pa-5 pad-actions justify-space-between">
        <v-btn depressed color="darken-1 error" @click.prevent="_clear()">
          {{ $t('clear') }}
        </v-btn>
        <div>
          <v-btn depressed color="darken-1" class="primary mr-2" text @click.prevent="_save()">
            {{ $t('confirm') }}
          </v-btn>

          <v-btn depressed color="darken-1" @click.prevent="hide()" outlined>
            {{ $t('close') }}
          </v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'SignPad',
  props: {},
  data: vm => ({
    open: false,
    options: {
      penColor: '#000',
      minWidth: 2,
      maxWidth: 2,
      backgroundColor: '#fff',
      onBegin: () => {
        vm.$refs.signaturePad.resizeCanvas()
      },
    },
    padH: '100%',
  }),
  methods: {
    show() {
      this.open = true
      this._handleResize()
      this.$refs.signaturePad.clearSignature()
    },
    hide() {
      this.open = false
    },
    _handleResize() {
      this.$nextTick(() => {
        const windowH = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
        if (document.querySelector('.pad-actions')) {
          const padAction = document.querySelector('.pad-actions')
          const rect = padAction.getBoundingClientRect()
          this.padH = `${windowH - rect.height}px`
        }
        this.$refs.signaturePad.resizeCanvas()
      })
    },
    _clear() {
      this.$refs.signaturePad.clearSignature()
    },
    _save() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature()
      if (isEmpty) return
      this.$emit('confirm', data)
      this.hide()
    },
  },
  destroyed() {
    window.removeEventListener('resize', this._handleResize)
  },
  mounted() {
    window.addEventListener('resize', this._handleResize)
  },
}
</script>
<style lang="scss" scoped>
::v-deep .pad-container {
  max-height: 100%;
}

::v-deep .pad-actions {
  border-top: 1px solid #000000;
}
</style>
